module InputTools {
	export function MakeReadOnly(element: JQuery<HTMLElement>) {
		element.prop("readonly", true);
	}

	export function MakeWritable(element: JQuery<HTMLElement>) {
		element.prop("readonly", false);
	}

	export function ToggleReadOnly(element: JQuery<HTMLElement>) {
		element.prop("readonly", !(element.prop("readonly") as boolean));
	}

	export function Enable(element: JQuery<HTMLElement>) {
		element.prop("disabled", false);
	}

	export function Disable(element: JQuery<HTMLElement>) {
		element.prop("disabled", true);
	}
}